import { NgModule } from '@angular/core';
import { SectionImageContentComponent } from './section-image-content.component';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CarouselModule.forRoot()
  ],
  declarations: [
    SectionImageContentComponent
  ],
  exports: [
    SectionImageContentComponent
  ]
})
export class SectionImageContentModule { }
